module.exports = __webpack_public_path__ + "static/hawaii-5-c7a5d987156c634c328b72266b33026c.png";